import { observer } from 'mobx-react-lite'
import { getAriaLabel } from 'shared/lib'
import { Avatar, Icon, Tooltip, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'
import styles from './styles.module.scss'

export const BroadcastAssigneeDropdownTrigger = observer(() => {
  const {
    broadcastAssigneeStore: { assignedMember, assignedCustom },
  } = useBroadcastViewContext()
  const { usersStore } = useEntitiesContext()

  const isOwner = assignedMember?.id === usersStore.user_owner_id
  const memberTooltipText = isOwner
    ? 'New conversations will be assigned to you. Existing — stay with who they’re already assigned to.'
    : 'New conversations go to the selected assignee. Existing ones stay with who they’re already assigned to.'

  return (
    <span className={styles.value}>
      {assignedMember ? (
        <>
          <div className={styles.icon}>
            <Avatar info={assignedMember.avatarInfo} size={16} />
          </div>
          <Typography
            className={styles.name}
            variant='body-md-regular'
            ellipsis
            pointer
            ariaLabel={'name'}
          >
            {assignedMember.name}
            {isOwner && ' (Assign to me)'}
          </Typography>
          <Tooltip type={'description'} width={258} label={memberTooltipText} placement={'top'}>
            <Icon icon={'question'} fontSize={12} color={'var(--content-neutral-primary)'} />
          </Tooltip>
        </>
      ) : assignedCustom ? (
        <>
          <div className={styles.icon}>
            <Icon icon={assignedCustom.icon} color='var(--content-primary-tertiary)' />
          </div>
          <Typography
            className={styles.name}
            variant='body-md-regular'
            pointer
            ariaLabel={getAriaLabel(assignedCustom.type)}
          >
            {assignedCustom.label}
          </Typography>
          {assignedCustom.tooltipText && (
            <Tooltip
              type={'description'}
              width={258}
              label={assignedCustom.tooltipText}
              placement={'top'}
            >
              <Icon icon={'question'} fontSize={12} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          )}
        </>
      ) : null}
    </span>
  )
})
